import { FC, ReactNode } from "react";
import styles from "./styles.module.scss";
import { useThrottle } from "@/common/hooks/useThrottle";
import { Spinner } from "@/shared/ui/Spinner";
import { twCn } from "@/styles/utils";

interface Props {
  id: string;
  children: ReactNode;
  onClick?: () => void;
  type?: "button" | "submit";
  outlined?: boolean;
  secondary?: boolean;
  warning?: boolean;
  toggleOffMode?: boolean;
  disabled?: boolean;
  className?: string;
  fullWidth?: boolean;
  selfStart?: boolean;
  selfCenter?: boolean;
  loading?: boolean;
  form?: string;
}

export const MainButton: FC<Props> = ({
  id,
  onClick,
  children,
  type = "button",
  outlined = false,
  secondary = false,
  warning = false,
  toggleOffMode = false,
  disabled = false,
  className,
  fullWidth = false,
  selfStart = false,
  selfCenter = false,
  loading = false,
  form,
}) => {
  const throttledClick = useThrottle(onClick);
  return (
    <button
      id={`${id}-button`}
      type={type}
      form={form}
      className={twCn(
        styles.mainButton,
        { [styles.secondary]: secondary },
        { [styles.warning]: warning },
        { [styles.outlined]: outlined },
        { [styles.disabled]: disabled || loading },
        { [styles.fullWidth]: fullWidth },
        toggleOffMode && styles.toggleOffMode,
        selfStart && "lgc:self-start",
        selfCenter && "lgc:self-center",
        className,
      )}
      onClick={throttledClick}
      disabled={disabled || loading}
    >
      <span className={styles.text}>{children}</span>
      {loading && (
        <div className={styles.spinnerWrapper}>
          <Spinner size={32} light narrow />
        </div>
      )}
    </button>
  );
};
